import { useState, useEffect } from 'react';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
import * as telegramApi from '../../api/telegram.api';
import styles from './TelegramConnect.module.css';

export function TelegramConnect() {
  const [linked, setLinked] = useState(false);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);
  const [fallbackLink, setFallbackLink] = useState<string | null>(null);

  useEffect(() => {
    telegramApi
      .getTelegramStatus()
      .then((status) => setLinked(status.linked))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const handleConnect = async () => {
    setActionLoading(true);
    setFallbackLink(null);
    const popup = window.open('', '_blank');
    try {
      const result = await telegramApi.generateTelegramLink();
      if (popup && !popup.closed) {
        popup.location.href = result.deepLink;
      } else {
        setFallbackLink(result.deepLink);
      }
    } catch {
      if (popup && !popup.closed) popup.close();
    } finally {
      setActionLoading(false);
    }
  };

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.icon}>
            <TelegramIcon />
          </div>
          <h3 className={styles.title}>Telegram</h3>
        </div>
        <p className={styles.description}>Загрузка...</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.icon}>
          <TelegramIcon />
        </div>
        <h3 className={styles.title}>Telegram</h3>
      </div>

      <p className={styles.description}>
        Подключите Telegram для получения уведомлений о подписке и быстрого управления
      </p>

      {linked ? (
        <div className={styles.linkedStatus}>
          <div className={styles.linkedInfo}>
            <Badge variant="success">Подключён</Badge>
            <span className={styles.linkedText}>Telegram подключён</span>
          </div>
        </div>
      ) : (
        <>
          <div className={styles.mergeNote}>
            <WarningIcon />
            <p className={styles.mergeNoteText}>
              Если вы уже пользовались ботом Norion в Telegram, после
              подключения этот аккаунт <strong>объединится</strong> с вашим
              Telegram-аккаунтом (подписка, ключи и история перенесутся).
              Убедитесь, что на этом устройстве в Telegram открыт нужный
              пользователь.
            </p>
          </div>

          <div className={styles.actions}>
            <Button
              variant="primary"
              size="sm"
              loading={actionLoading}
              onClick={handleConnect}
            >
              Подключить Telegram
            </Button>
          </div>

          {fallbackLink && (
            <div className={styles.deepLinkBlock}>
              <p className={styles.deepLinkHint}>
                Браузер заблокировал автоматическое открытие. Нажмите, чтобы открыть бота в Telegram
              </p>
              <a href={fallbackLink} target="_blank" rel="noopener noreferrer">
                <Button variant="secondary" size="sm">
                  Открыть Telegram
                </Button>
              </a>
            </div>
          )}
        </>
      )}
    </div>
  );
}

function WarningIcon() {
  return (
    <svg className={styles.mergeNoteIcon} width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
}

function TelegramIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="m22 2-7 20-4-9-9-4z" />
      <path d="M22 2 11 13" />
    </svg>
  );
}
